import consumer from "./consumer";

document.addEventListener('turbolinks:load', (e) => {
  if (document.querySelector('.progress')) {
    consumer.subscriptions.create({
      channel: "SyncProgressChannel",
      provider_id: document.querySelector('.progress').dataset.providerId
    },

    {
      connected() {
        // Called when the subscription is ready for use on the server
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Select sync elements
        const progressBar     = document.querySelector('.progress-bar.sync-progress'),
              progressMessage = document.querySelector('.sync-progress-message'),
              providerLink    = document.querySelector('.provider-show-link'),
              retryLink       = document.querySelector('.retry-sync-link'),
              secondsCounter  = document.querySelector('.js-seconds-counter'),
              spinIcon        = document.querySelector('.spinner-border');

        // Set sync progress values
        progressBar.setAttribute('style', `width: ${data['progress_percentage']}%`);
        progressBar.setAttribute('aria-valuenow', data['progress_percentage']);
        progressMessage.innerText = data['message'];

        // If sync is completed or we encounter an error, remove stripes and animation
        // classes and change progress bar color accordingly
        if (data['progress_percentage'] == '100') {
          progressBar.classList.remove('progress-bar-animated', 'progress-bar-striped');
          secondsCounter.classList.add('d-none');
          spinIcon.classList.add('d-none');

          if (data['error']) {
            progressBar.classList.add('bg-danger');
            retryLink.classList.remove('d-none');
          } else {
            progressBar.classList.add('bg-success');
            providerLink.classList.remove('d-none');
          }
        }
      }
    });
  }
});
